/* Navigation – Version 2: desktop dropdown panels + mobile drawer accordion. */
(function () {
  if (window.megaMenuV2Loaded) return;
  window.megaMenuV2Loaded = true;

  const OPEN_CLASS = 'is-open';

  function closePanels() {
    document.querySelectorAll('.mega-v2.' + OPEN_CLASS + ', [data-mega-v2-overlay].' + OPEN_CLASS).forEach((el) => {
      el.classList.remove(OPEN_CLASS);
    });
    document.querySelectorAll('[data-mega-v2-target][aria-expanded="true"]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanel(panel) {
    closePanels();
    panel.classList.add(OPEN_CLASS);
    const overlay = document.querySelector('[data-mega-v2-overlay]');
    if (overlay) overlay.classList.add(OPEN_CLASS);
    const trigger = document.querySelector('[data-mega-v2-target="' + panel.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    document.body.classList.remove('nav-open');
    const navToggle = document.querySelector('[data-component="nav-toggle"]');
    if (navToggle) navToggle.classList.remove('is-active');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mega-v2-target]');
    if (trigger) {
      event.preventDefault();
      const panel = document.getElementById(trigger.dataset.megaV2Target);
      if (!panel) return;
      if (panel.classList.contains(OPEN_CLASS)) {
        closePanels();
      } else {
        openPanel(panel);
      }
      return;
    }

    const accordionToggle = event.target.closest('[data-mnav-v2-toggle]');
    if (accordionToggle) {
      const isOpen = accordionToggle.parentElement.classList.toggle(OPEN_CLASS);
      accordionToggle.setAttribute('aria-expanded', isOpen);
      return;
    }

    if (event.target.closest('[data-mnav-v2-close]')) {
      closeDrawer();
      return;
    }

    if (!event.target.closest('.mega-v2')) closePanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closePanels();
    if (document.body.classList.contains('nav-open')) closeDrawer();
  });

  // Theme editor: show a block's dropdown while it is selected.
  document.addEventListener('shopify:block:select', (event) => {
    const panel = document.getElementById('MegaV2-' + event.detail.blockId);
    if (panel) openPanel(panel);
  });
  document.addEventListener('shopify:block:deselect', closePanels);
})();
